export default __webpack_public_path__ + "static/media/c3-loading.e04687b3.svg";